// Standard international countries list with Pakistan pinned to top
export const COUNTRIES = [
  { name: "Pakistan", code: "PK", dialCode: "92" },
  { name: "Afghanistan", code: "AF", dialCode: "93" },
  { name: "Albania", code: "AL", dialCode: "355" },
  { name: "Algeria", code: "DZ", dialCode: "213" },
  { name: "Andorra", code: "AD", dialCode: "376" },
  { name: "Angola", code: "AO", dialCode: "244" },
  { name: "Argentina", code: "AR", dialCode: "54" },
  { name: "Armenia", code: "AM", dialCode: "374" },
  { name: "Australia", code: "AU", dialCode: "61" },
  { name: "Austria", code: "AT", dialCode: "43" },
  { name: "Azerbaijan", code: "AZ", dialCode: "994" },
  { name: "Bahamas", code: "BS", dialCode: "1242" },
  { name: "Bahrain", code: "BH", dialCode: "973" },
  { name: "Bangladesh", code: "BD", dialCode: "880" },
  { name: "Belarus", code: "BY", dialCode: "375" },
  { name: "Belgium", code: "BE", dialCode: "32" },
  { name: "Bosnia and Herzegovina", code: "BA", dialCode: "387" },
  { name: "Brazil", code: "BR", dialCode: "55" },
  { name: "Bulgaria", code: "BG", dialCode: "359" },
  { name: "Cambodia", code: "KH", dialCode: "855" },
  { name: "Canada", code: "CA", dialCode: "1" },
  { name: "Chile", code: "CL", dialCode: "56" },
  { name: "China", code: "CN", dialCode: "86" },
  { name: "Colombia", code: "CO", dialCode: "57" },
  { name: "Croatia", code: "HR", dialCode: "385" },
  { name: "Cyprus", code: "CY", dialCode: "357" },
  { name: "Czech Republic", code: "CZ", dialCode: "420" },
  { name: "Denmark", code: "DK", dialCode: "45" },
  { name: "Egypt", code: "EG", dialCode: "20" },
  { name: "Estonia", code: "EE", dialCode: "372" },
  { name: "Finland", code: "FI", dialCode: "358" },
  { name: "France", code: "FR", dialCode: "33" },
  { name: "Georgia", code: "GE", dialCode: "995" },
  { name: "Germany", code: "DE", dialCode: "49" },
  { name: "Ghana", code: "GH", dialCode: "233" },
  { name: "Greece", code: "GR", dialCode: "30" },
  { name: "Hong Kong", code: "HK", dialCode: "852" },
  { name: "Hungary", code: "HU", dialCode: "36" },
  { name: "Iceland", code: "IS", dialCode: "354" },
  { name: "India", code: "IN", dialCode: "91" },
  { name: "Indonesia", code: "ID", dialCode: "62" },
  { name: "Iran", code: "IR", dialCode: "98" },
  { name: "Iraq", code: "IQ", dialCode: "964" },
  { name: "Ireland", code: "IE", dialCode: "353" },
  { name: "Italy", code: "IT", dialCode: "39" },
  { name: "Japan", code: "JP", dialCode: "81" },
  { name: "Jordan", code: "JO", dialCode: "962" },
  { name: "Kazakhstan", code: "KZ", dialCode: "7" },
  { name: "Kenya", code: "KE", dialCode: "254" },
  { name: "Kuwait", code: "KW", dialCode: "965" },
  { name: "Kyrgyzstan", code: "KG", dialCode: "996" },
  { name: "Lebanon", code: "LB", dialCode: "961" },
  { name: "Libya", code: "LY", dialCode: "218" },
  { name: "Luxembourg", code: "LU", dialCode: "352" },
  { name: "Malaysia", code: "MY", dialCode: "60" },
  { name: "Maldives", code: "MV", dialCode: "960" },
  { name: "Mexico", code: "MX", dialCode: "52" },
  { name: "Morocco", code: "MA", dialCode: "212" },
  { name: "Nepal", code: "NP", dialCode: "977" },
  { name: "Netherlands", code: "NL", dialCode: "31" },
  { name: "New Zealand", code: "NZ", dialCode: "64" },
  { name: "Nigeria", code: "NG", dialCode: "234" },
  { name: "Norway", code: "NO", dialCode: "47" },
  { name: "Oman", code: "OM", dialCode: "968" },
  { name: "Palestine", code: "PS", dialCode: "970" },
  { name: "Philippines", code: "PH", dialCode: "63" },
  { name: "Poland", code: "PL", dialCode: "48" },
  { name: "Portugal", code: "PT", dialCode: "351" },
  { name: "Qatar", code: "QA", dialCode: "974" },
  { name: "Romania", code: "RO", dialCode: "40" },
  { name: "Russia", code: "RU", dialCode: "7" },
  { name: "Saudi Arabia", code: "SA", dialCode: "966" },
  { name: "Singapore", code: "SG", dialCode: "65" },
  { name: "South Africa", code: "ZA", dialCode: "27" },
  { name: "South Korea", code: "KR", dialCode: "82" },
  { name: "Spain", code: "ES", dialCode: "34" },
  { name: "Sri Lanka", code: "LK", dialCode: "94" },
  { name: "Sudan", code: "SD", dialCode: "249" },
  { name: "Sweden", code: "SE", dialCode: "46" },
  { name: "Switzerland", code: "CH", dialCode: "41" },
  { name: "Syria", code: "SY", dialCode: "963" },
  { name: "Tajikistan", code: "TJ", dialCode: "992" },
  { name: "Tanzania", code: "TZ", dialCode: "255" },
  { name: "Thailand", code: "TH", dialCode: "66" },
  { name: "Tunisia", code: "TN", dialCode: "216" },
  { name: "Turkey", code: "TR", dialCode: "90" },
  { name: "Turkmenistan", code: "TM", dialCode: "993" },
  { name: "Uganda", code: "UG", dialCode: "256" },
  { name: "Ukraine", code: "UA", dialCode: "380" },
  { name: "United Arab Emirates", code: "AE", dialCode: "971" },
  { name: "United Kingdom", code: "GB", dialCode: "44" },
  { name: "United States", code: "US", dialCode: "1" },
  { name: "Uzbekistan", code: "UZ", dialCode: "998" },
  { name: "Vietnam", code: "VN", dialCode: "84" },
  { name: "Yemen", code: "YE", dialCode: "967" },
  { name: "Zimbabwe", code: "ZW", dialCode: "263" },
];

/**
 * Normalizes an input phone number to strict E.164 format.
 * Returns null if the number lacks a country code or has invalid length/characters.
 */
export function normalizePhone(input) {
  if (!input || typeof input !== "string") return null;

  // Strip allowed formatting characters: spaces, hyphens, dots, parentheses
  let cleaned = input.trim().replace(/[\s\-().]/g, "");

  // Convert leading 00 to +
  if (cleaned.startsWith("00")) {
    cleaned = "+" + cleaned.slice(2);
  }

  // Strict: must start with +
  if (!cleaned.startsWith("+")) {
    return null;
  }

  const digits = cleaned.slice(1);
  // ITU-T E.164 specifies between 8 and 15 digits
  if (!/^\d{8,15}$/.test(digits)) {
    return null;
  }

  return cleaned;
}

/**
 * Parses an E.164 or legacy phone number against a list of countries.
 * Matches the longest country dialCode prefix.
 */
export function parsePhoneNumber(value, countries = COUNTRIES) {
  if (!value || typeof value !== "string") {
    return { country: null, nationalNumber: "", isValid: false, isLegacy: false };
  }

  const trimmed = value.trim();
  let normalized = trimmed.replace(/[\s\-().]/g, "");

  if (normalized.startsWith("00")) {
    normalized = "+" + normalized.slice(2);
  }

  if (normalized.startsWith("+")) {
    const digits = normalized.slice(1);

    // Sort countries by descending length of dialCode for longest-prefix matching
    const sortedCountries = [...countries]
      .filter((c) => c && (c.dialCode || c.phoneCode))
      .sort((a, b) => {
        const aCode = String(a.dialCode || a.phoneCode).replace(/\D/g, "");
        const bCode = String(b.dialCode || b.phoneCode).replace(/\D/g, "");
        return bCode.length - aCode.length;
      });

    for (const c of sortedCountries) {
      const pCode = String(c.dialCode || c.phoneCode).replace(/\D/g, "");
      if (pCode && digits.startsWith(pCode)) {
        const national = digits.slice(pCode.length);
        const isValid = digits.length >= 8 && digits.length <= 15;
        return {
          country: c,
          nationalNumber: national,
          isValid,
          isLegacy: false,
        };
      }
    }

    // Starts with + but no matching country in list
    return {
      country: null,
      nationalNumber: digits,
      isValid: digits.length >= 8 && digits.length <= 15,
      isLegacy: false,
    };
  }

  // Does not start with + or 00 -> legacy stored value
  return {
    country: null,
    nationalNumber: trimmed,
    isValid: false,
    isLegacy: true,
  };
}

/**
 * Combines country dial code and national digits into E.164 string.
 */
export function formatE164(dialCode, nationalNumber) {
  if (!dialCode || !nationalNumber) return "";
  const cleanCode = String(dialCode).replace(/\D/g, "");
  // Strip leading 0 from national number
  let cleanNational = String(nationalNumber).replace(/\D/g, "");
  if (cleanNational.startsWith("0")) {
    cleanNational = cleanNational.replace(/^0+/, "");
  }
  if (!cleanCode || !cleanNational) return "";
  return `+${cleanCode}${cleanNational}`;
}

